import React, { Component } from 'react';
import { Button } from '@comall-backend-builder/components-basis';
import { services } from '@comall-backend-builder/core';
import { message as AntMessage } from 'antd';

import { errorHandle } from '../../services';

const api = services.api;

export class LiveRoomAddProductBtn extends Component<any, any> {

    add = () => {
        const { roomid, row: { id } } = this.props;
        
        api.post(
            { ids: id },
            { apiPath: `/live/room/import/${roomid}` }
        ).then(() => {
            // 提示
            AntMessage.success('导入成功');
        })
        .catch(errorHandle);
    }

    render() {
        const btnProps = {
            text: '导入',
            onClick: this.add
        };
        return <Button {...btnProps} type='link' />;
    }
}